import { buildQueryString } from '@/utils/buildQueryString';

const API_BASE =
    process.env.REACT_APP_API_BASE || 'http://local.thecyberhawkdev.com:8181';

const API_PREFIX = '/json-api/v1';

const WEB_PREFIX = '/';

const SORTING_TOOL_PREFIX = 'image-sorting';

const MAIN_IHAWK_URL = process.env.REACT_APP_MAIN_URL;

const API_PREFIX_GENERIC = `${API_PREFIX}/generic`;

const API_PREFIX_CONSTRUCTION = `${API_PREFIX}/construction`;

const API_PREFIX_BUILDER = `${API_PREFIX}/builder`;

const API_PREFIX_IMAGE_SORTING = `${API_PREFIX}/${SORTING_TOOL_PREFIX}`;

const BUILD_API_URL = (endpoint = '', prefix = API_PREFIX) =>
    `${prefix}${endpoint}`;
const BUILD_WEB_URL = (endpoint = '', parameters = {}) => {
    const queryString = buildQueryString(parameters);
    return `${endpoint}${
        Object.keys(parameters).length > 0 ? queryString : ''
    }`;
};

const CDN_ENDPOINT = process.env.REACT_APP_CDN_ENDPOINT;
const UPLOAD_ENDPOINT = process.env.REACT_APP_UPLOAD_ENDPOINT;

export {
    API_BASE,
    API_PREFIX,
    API_PREFIX_BUILDER,
    API_PREFIX_CONSTRUCTION,
    API_PREFIX_GENERIC,
    API_PREFIX_IMAGE_SORTING,
    BUILD_API_URL,
    BUILD_WEB_URL,
    CDN_ENDPOINT,
    MAIN_IHAWK_URL,
    SORTING_TOOL_PREFIX,
    UPLOAD_ENDPOINT,
    WEB_PREFIX,
};
